export default __webpack_public_path__ + "static/media/eye.01e3bfbc.svg";